<template>
  <div v-if="user" class="user">
    <div class="user-avatar" :class="inner ? 'inner' : ''">
      <el-avatar :size="avatarSize" :src="user.imageAddress || avatarUrl" @click.native="openUserDetail(user.id)"></el-avatar>
      <div class="user-avatar-seed" v-if="user && user.state === 3">
        <img :src="require('@/assets/images/seed.png')" class="seed" />
      </div>
    </div>
    <div class="user-name">{{user.name}}</div>
    <div class="user-info flex">
      <span>
        <span class="num">{{ user.createNum }}</span> <br /> 创作数
      </span>
      <span>
        <span class="num">{{ user.fansCount }}</span> <br /> 粉丝
      </span>
    </div>
    <div class="user-oper">
      <template v-if="isOwner">
        <slot name="button"></slot>
      </template>
      <template v-else>
        <el-button :type="isFollow ? '' : 'primary'" size="small"  @click="toggleFollow">
          {{ isFollow ? '取消关注' : '关注' }}
        </el-button>
        <el-tooltip effect="dark" content="该功能暂未开放哟~" placement="bottom-start">
          <el-button size="small">聊TA</el-button>
        </el-tooltip>
      </template>
    </div>
  </div> 
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import {
  isAttentionUser,
  attentionUser,
  unAttentionUser
} from '@/api/user';
export default {
  name: 'UserCardNew',
  inject: ['checkToken'],
  props: {
    // 用户信息
    user: {
      type: Object,
      required: true,
    },
    // 用户头像大小
    avatarSize: {
      type: Number,
      required: false,
      default: () => 90,
    },
    // 是否内嵌卡片
    inner: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  data: () => ({
    avatarUrl: '/static/images/user.png', 
    isFollow: false,
  }),
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler() {
        this.isAttentionUser();
      },
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    isOwner() {
      let isOwner = false;
      if (this.userInfo && this.user && this.userInfo.id === this.user.id) {
        isOwner = true;
      }
      return isOwner;
    }
  },
  methods: {
    // 跳转至用户详情
    openUserDetail(id) {
      this.$router.push({
        name: 'User',
        params: { id }
      });
    },
    // 判断是否已关注用户
    isAttentionUser() {
      if (this.userInfo && this.user) {
        isAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code, data }) => {
          if (code === 0) {
            this.isFollow = data;
          }
        });
      }
    },
    // 点击关注用户
    toggleFollow: debounce(function (){
      if (!this.checkToken()) return;
      if (this.isFollow) {
        unAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
          if (code === 0) {
            this.$message.success('已取消关注');
            this.isFollow = false;
          }
        });
      } else {
        attentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
          if (code === 0) {
            this.$message.success('关注成功');
            this.isFollow = true;
          }
        });
      }
    }, 300),
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 30px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 2px rgba(153, 154, 172, .1);
  border-radius: 4px;
  text-align: center;  
  &-name {
    margin-top: 20px;
    @include font(#333, 20px, 600);
  }
  &-oper {
    .el-button {
      width: 80px;
    }
  }
  &-info {
    padding: 10px 0;
    justify-content: space-evenly;
    @include font(#999, 14px, 400);
    .num {
      @include font(#333, 18px, 600);
    }
  }
  &-avatar {
    position: relative;
    display: inline-block;
    &-seed {
      position: absolute;
      right: -32px;
      top: -10px;
    }
    &.inner {
      .user-avatar {
        &-seed {
          right: -15px;
          top: -10px;
          .seed {
            width: 16px;
          }
        }
      }
    }
  }
}
</style>
